export const ORG_PROJECTION_WAIT_MS = 15_000;

/**
 * Keeps the raw org scene hidden only for a bounded host-preparation window.
 * The plugin load itself is deliberately not cancelled: a slow chunk may
 * still publish the proper projection later, while the user gets a usable raw
 * scene instead of a permanently blank canvas in the meantime.
 */
export function releaseOrgProjectionHold(input: {
  load: () => Promise<unknown>;
  release: () => void;
  timeoutMs?: number;
}): () => void {
  let active = true;
  const release = () => {
    if (!active) return;
    active = false;
    clearTimeout(timer);
    input.release();
  };
  const timer = setTimeout(release, input.timeoutMs ?? ORG_PROJECTION_WAIT_MS);
  void input.load().catch(release);
  return () => {
    active = false;
    clearTimeout(timer);
  };
}
